export enum TableColumnColorEnum {
  ORANGE = 'primary',
  GREEN = 'secondary',
  RED = 'warning',
  GREY = 'text-on-light',
  DARK = 'titles'
}
